// SPDX-FileCopyrightText: 2024 Felix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var UPSERT_AREAS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation UpsertAreas($electionEventId: String!, $documentId: String!) {\n        upsert_areas(election_event_id: $electionEventId, document_id: $documentId) {\n            id\n        }\n    }\n"], ["\n    mutation UpsertAreas($electionEventId: String!, $documentId: String!) {\n        upsert_areas(election_event_id: $electionEventId, document_id: $documentId) {\n            id\n        }\n    }\n"])));
var templateObject_1;
